import {put} from "redux-saga/effects";

import axios from "../../../../../api/axios"

import * as actions from "../../../../actions";
import * as api from "../../../../../api";
import {generateDynamicRoute} from "../../../../../utils/utils";

export function* enseignantMesCoursAjouterSectionSaga (action) {

    yield put(actions.enseignantMesCoursAjouterSectionStart());

    const section = action.payload.section;

    try {
        const response = yield axios.post(api.enseignantAjouterSection,section);
        yield put(actions.enseignantMesCoursAjouterSectionSuccess(response.data));
    } catch (error) {
        if(error.response) {
            yield put(actions.enseignantMesCoursAjouterSectionFail(error.response.data.error));
        }else {
            yield put(actions.enseignantMesCoursAjouterSectionFail("There's an error!"));
        }
    }
}

